import { type Feature } from 'ol';
import { extend as extendExtent } from 'ol/extent';
import { get as getProjection } from 'ol/proj';
import type VectorSource from 'ol/source/Vector';

/**
 * Area da interrogare nelle sorgenti di calcolo: l'estensione delle geometrie
 * disegnate, compresa la feature appena aggiunta o modificata.
 */
export function getCalculationArea(
  drawnSource: VectorSource,
  feature?: Feature,
) {
  const featureGeom = feature?.getGeometry();
  const extent = featureGeom
    ? extendExtent(drawnSource.getExtent(), featureGeom.getExtent())
    : drawnSource.getExtent();
  // La sorgente di disegno non ha una proiezione propria e getProjection()
  // restituisce null: senza fallback non si carica nulla e le tabelle delle
  // intersezioni restano vuote.
  const projection = drawnSource.getProjection() ?? getProjection('EPSG:3857');
  return { extent, projection };
}
